import React, { useCallback, useState } from 'react'
import CommonTable from '../../CommonTable/CommonTable'
import { FormattedMessage, useIntl } from 'react-intl'
import Link from '../../Link/Link'
import CustomConfirmModal from '../../Common/CustomConfirmModal/CustomConfirmModal'
import { deleteReportTypeData } from '../../../actions/ReportType/manageReportTypeAction'
import { useDispatch } from 'react-redux';
import messages from '../../../locale/jsonMessages';
import { getDynamicReportContent, getDynamicReportTypeData } from '../../../helpers/GetDynamicItemName/dynamicReportTypeHelper'


function ReportTypeManagement(props) {
    const { getAllReportType, refetch, currentPage, setStateVariable, searchList } = props;
    const intl = useIntl()
    const dispatch = useDispatch();
    const { locale } = intl;
    const [modalState, setModalState] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    const openDeleteModal = useCallback((id) => {
        setSelectedId(id);
        setModalState(true)
    }, [])

    const handleSearchChange = useCallback((event) => {
        let searchList = event.target.value
        let variables = {
            currentPage: 1,
            searchList
        };
        setStateVariable(variables);
        refetch(variables);
    }, [refetch])

    const thead = () => {
        return [
            { data: intl.formatMessage(messages.idLabel) },
            { data: intl.formatMessage(messages.tabTitle) },
            { data: intl.formatMessage(messages.contentLabel) },
            { data: intl.formatMessage(messages.editLabel) },
            { data: intl.formatMessage(messages.delete) }
        ]
    }
    const handleDelete = async (id, currentPage) => {
        setModalState(false)
        const pageResults = getAllReportType?.results || [];
        const updatedPage = currentPage > 1 && pageResults.length === 1 ? currentPage - 1 : currentPage;
        await dispatch(deleteReportTypeData(id));
        const variables = { searchList, currentPage: updatedPage };
        await setStateVariable(variables);
        refetch(variables);
    };

    let reportTypeData = getAllReportType?.results && getAllReportType?.results.length > 0 ? getAllReportType?.results : [];

    const tbody = () => {
        return reportTypeData.map((value) => {
            let reportType, reportContent;
            reportType = value?.DynamicReportTypeData && value?.DynamicReportTypeData.length > 0 ? getDynamicReportTypeData({ value: value?.reportType, locale, data: value?.DynamicReportTypeData }) : value?.reportType;
            reportContent = value?.DynamicReportTypeData && value?.DynamicReportTypeData.length > 0 ? getDynamicReportContent({ value: value?.reportContent, locale, data: value?.DynamicReportTypeData }) : value?.reportContent;
            return {
                id: value?.id,
                data: [
                    { data: value?.id },
                    { data: reportType },
                    { data: reportContent },
                    { data: <div><Link to={`/siteadmin/report-type/edit/${value?.id}`}><FormattedMessage  {...messages.editLabel} /></Link></div> },
                    {
                        data: (
                            <div>
                                <a href="javascript:void(0)" onClick={() => openDeleteModal(value?.id)}>
                                    <FormattedMessage  {...messages.delete} />
                                </a>
                            </div>
                        ),
                    }
                ]
            }
        })
    }


    return (
        <div>
            {modalState &&
                <CustomConfirmModal
                    showModel={modalState}
                    title={intl.formatMessage(messages.deleteReportType)}
                    bodyText={intl.formatMessage(messages.deleteReportTypeConfirm)}
                    closeModal={() => setModalState(false)}
                    popupButtonLeftFunction={() => setModalState(false)}
                    popupButtonLeftName={intl.formatMessage(messages.cancel)}
                    popupButtonRightFunction={() => handleDelete(selectedId, currentPage)}
                    popupButtonRightName={intl.formatMessage(messages.proceed)}
                />
            }
            <CommonTable
                thead={thead}
                tbody={tbody}
                title={intl.formatMessage(messages.reportTypeManagement)}
                isLink
                isSearch
                redirectionLabel={intl.formatMessage(messages.addNewLabel)}
                href={'/siteadmin/report-type/add'}
                onSearch={(event) => handleSearchChange(event)}
            />
        </div>
    )
}

export default (ReportTypeManagement);

